<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-6 col-lg-4 g-0">
      <div class="card my-3">
        <app-user-title title="{{ user ? user.getName() : 'profiel'}}" [icon]="faUserCirlce">
        </app-user-title>

        @if(!processing()) {
          <div class="card-body card-body-auth">
            @if(alert) {
              <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
            }
            <div class="card-body card-body-auth">
              <form name="form" (ngSubmit)="save()" [formGroup]="form" novalidate>
                @if(user) {                  
                  <div class="form-group row">
                    <div class="col-3">
                      <label for="emailaddress" class="col-form-label">emailadres</label>
                    </div>
                    <div class="col-9">
                      <input class="form-control"
                        ngClass="{ 'is-invalid': form.controls.emailaddress.invalid, 'is-valid': form.controls.emailaddress.valid }"
                        type="text" formControlName="emailaddress" placeholder="max. {{validations.maxlengthemailaddress}} karakters">
                    </div>
                  </div>                
                  <div class="form-group row justify-content-end mt-3">
                    <div class="col-9">
                      <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
                        opslaan
                      </button>
                    </div>
                  </div>
                }
                <div class="form-group row justify-content-end mt-3">
                  <div class="col-9">
                    <button (click)="navigateToLogout()" class="btn btn-secondary" role="button"
                      aria-label="uitloggen">
                      uitloggen
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        } @else {
          <h2 class="text-center">
            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          </h2>
        }      
    </div>
  </div>
</div>